import axios from "axios";

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE,
});

axiosInstance.interceptors.response.use(
  (response) => {
    const listData = response.data?.data;
    if (Object.isExtensible(listData)) {
      listData.total_page = listData.totalPages;
      listData.total_elements = listData.totalElements;
      listData.number_of_element = listData.numberOfElements;
    }

    return response;
  },
  (error) => {
    if (axios.isCancel(error)) {
      console.error("Found canceled axios in response: ", error.message);
      return Promise.resolve(error.message);
    }

    return Promise.reject(error);
  },
);

axiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    if (axios.isCancel(error)) {
      console.error("Found canceled axios in request: ", error.message);
      return Promise.resolve(error.message);
    }
    return Promise.reject(error);
  },
);

export { axiosInstance };
